// src/components/CodeEditor/Output.jsx

import { useState } from 'react';
import { Box, Typography, Button, CircularProgress, Snackbar, Alert } from '@mui/material';
import { executeCode } from '../../services/api';

const Output = ({ editorRef, language }) => {
  const [output, setOutput] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');

  const runCode = async () => {
    const sourceCode = editorRef.current.getValue();
    if (!sourceCode) return;
    try {
      setIsLoading(true);
      const { run: result } = await executeCode(language, sourceCode);
      setOutput(result.output.split('\n'));
      result.stderr ? setIsError(true) : setIsError(false);
    } catch (error) {
      console.log(error);
      setSnackbarMessage(error.message || 'Unable to run code');
      setSnackbarOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  return (
    <Box sx={{ width: '50%' }}>
      <Typography variant="h6" component="p" sx={{ mb: 1 }}>
        Output
      </Typography>
      <Button
        variant="outlined"
        color="success"
        onClick={runCode}
        disabled={isLoading}
        sx={{ mb: 2 }}
      >
        {isLoading ? <CircularProgress size={24} color="inherit" /> : 'Run Code'}
      </Button>
      <Box
        sx={{
          height: '75vh',
          p: 1,
          color: isError ? 'error.main' : 'inherit',
          border: '1px solid',
          borderRadius: 1,
          borderColor: isError ? 'error.main' : 'grey.800',
          overflowY: 'auto',
        }}
      >
        {output
          ? output.map((line, i) => <Typography key={i} sx={{ whiteSpace: 'pre-wrap' }}>{line}</Typography>)
          : 'Click "Run Code" to see the output here'}
      </Box>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert onClose={handleSnackbarClose} severity="error" sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Output;